// extracted by mini-css-extract-plugin
export default {"success":"default_success__BQYjN","thumb":"default_thumb__EvjzH","icon":"default_icon__VWM1o","header":"default_header__M+Dc8","content":"default_content__hZvpk"};